export default __webpack_public_path__ + "static/SiemensProgress-Regula-master-753db7575d5dcc8251cfb3277fab61f6.woff2";